<script>
import { cloneDeep } from 'lodash-es';
import { mapActions, mapState } from 'vuex';
import TwTitleBar from '../../components/TwTitleBar';
import NonDynamicTransportWrapper from '../../components/non-dynamic-transport/NonDynamicTransportWrapper';
import transportIndex from '../../variables/transportIndexes';

export default {
  name: 'NonDynamicTransportCreate',
  components: {
    TwTitleBar,
    NonDynamicTransportWrapper,
  },
  props: {
    transport: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      breadcrumbs: [
        { text: this.$t('menu.nonDynamicTransport.title'), to: '', disabled: true },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ],
      defaultTransport: {
        type: null,
        allotment: null,
        siblingId: null,
        supplierId: null,
        ticketHandling: null,
        allotments: [],
        ages: {
          infant: null,
          child: null,
        },
        outbound: [],
        inbound: [],
      },
      defaultTrip: {
        id: null,
        departureTime: null,
        departureOffsetDays: null,
        arrivalTime: null,
        arrivalOffsetDays: null,
        ref: null,
        carrier: {
          id: null,
          name: null,
        },
        departureTransit: {
          id: null,
          name: null,
        },
        arrivalTransit: {
          id: null,
          name: null,
        },
        duration: null,
      },
      defaultTripSeating: {
        id: null,
        transportSeatingSectionId: null,
        fromRow: null,
        toRow: null,
        comment: null,
        price: null,
        optional: false,
      },
      defaultTripConsumables: {
        id: null,
        transportConsumableTypeId: null,
        comment: null,
        price: null,
        optional: false,
      },
      defaultTripUpgrade: {
        id: null,
        transportUpgradeTypeId: null,
        comment: null,
        price: null,
      },
      defaultLuggage: {
        id: null,
        transportId: null,
        transportLuggageTypeId: null,
        amount: null,
        weight: null,
        height: null,
        width: null,
        length: null,
        price: null,
        oddType: false,
        inclusive: false,
        comment: null,
        concept: null,
      },
      localTransports: [],
      inboundSet: false,
      showHomeBound: true,
      siblingCreated: false,
      alert: {
        show: false,
        message: null,
        type: null,
      },
      baseTransportIndex: transportIndex.BASE_TRANSPORT_INDEX,
      siblingTransportIndex: transportIndex.SIBLING_TRANSPORT_INDEX,
      localBaseTransport: null,
      localSiblingTransport: null,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getNonDynamicTransport(this.$route.params.id);
    }

    if (this.baseTransport && this.$route.params.id) {
      this.localBaseTransport = cloneDeep(this.baseTransport);
    } else {
      this.localBaseTransport = cloneDeep(this.defaultTransport);
    }

    if (this.siblingTransport) {
      this.localSiblingTransport = cloneDeep(this.siblingTransport);
    }
  },
  computed: {
    ...mapState({
      baseTransport: state => state.nonDynamicTransport.transport.item,
      siblingTransport: state => state.nonDynamicTransport.siblingTransport.item,
    }),
  },
  watch: {
    localBaseTransport: {
      handler(value) {
        if (typeof value.inbound !== 'undefined') {
          const currentTrip = JSON.stringify(value.inbound[0]);
          const defaultTrip = JSON.stringify(this.defaultTrip);
          if (currentTrip === defaultTrip) {
            this.inboundSet = false;
          } else this.inboundSet = value.inbound.length !== 0;
        }
      },
      deep: true,
    },
    baseTransport(value) {
      if (value) {
        this.localBaseTransport = cloneDeep(value);
      }
    },
    siblingTransport(value) {
      this.localSiblingTransport = cloneDeep(value);
    },
  },
  methods: {
    ...mapActions({
      saveBaseTransport: 'nonDynamicTransport/saveBaseTransport',
      saveSiblingTransport: 'nonDynamicTransport/saveSiblingTransport',
      getNonDynamicTransport: 'nonDynamicTransport/getNonDynamicTransport',
    }),
    createSibling() {
      if (this.baseTransport && !this.inboundSet) {
        this.siblingCreated = true;
        this.localSiblingTransport = cloneDeep(this.defaultTransport);
        this.localBaseTransport.id = this.baseTransport.id;
        this.localSiblingTransport.type = this.baseTransport.type;
        this.localSiblingTransport.siblingId = this.baseTransport.id;
      } else {
        this.setAlert(this.$t('nonDynamicTransport.alerts.siblingCreation'), 'info', false);
      }
    },
    deleteSibling() {
      this.localSiblingTransport = null;
      this.siblingCreated = false;
      // TODO: Call delete transportation.
    },
    updateTransport(transport) {
      if (transport.index === this.baseTransportIndex) {
        this.localBaseTransport = transport.value;
      } else {
        this.localSiblingTransport = transport.value;
      }
    },
    saveTransport(value) {
      const { index, transport } = value;
      if (index === this.baseTransportIndex) {
        if (!this.inboundSet) {
          this.localBaseTransport.inbound = [];
        }
        if (JSON.stringify(transport) !== JSON.stringify(this.baseTransport)) {
          this.saveBaseTransport(transport);
        } else {
          this.setAlert(this.$t('nonDynamicTransport.alerts.noChanges'), 'info', false);
        }
      } else {
        this.saveSiblingTransport(transport);
      }
    },
    setAlert(message, type, timeout) {
      this.alert.show = true;
      this.alert.message = message;
      this.alert.type = type;
      if (timeout) {
        setTimeout(() => { this.alert.show = !this.alert.show; }, 2000);
      }
    },
  },
};
</script>


<template>
  <v-content>
    <div>
      <v-alert
        v-model="alert.show"
        class="alert"
        dismissible
        :type="alert.type"
      >
        {{ this.alert.message }}
      </v-alert>
    </div>
    <tw-title-bar
      :title="$t('menu.nonDynamicTransport.pages.create.title')"
      :breadcrumbs="breadcrumbs"
    >
    </tw-title-bar>
    <div class="pa-2">
      <non-dynamic-transport-wrapper
        v-if="localBaseTransport"
        :index="baseTransportIndex"
        :transport="localBaseTransport"
        :default-transport="defaultTransport"
        :default-trip="defaultTrip"
        :default-trip-seating="defaultTripSeating"
        :default-trip-consumables="defaultTripConsumables"
        :default-trip-upgrade="defaultTripUpgrade"
        :default-luggage="defaultLuggage"
        :sibling-created="siblingCreated"
        @update="updateTransport"
        @save="saveTransport"
      />
      <non-dynamic-transport-wrapper
        v-if="localSiblingTransport"
        :index="siblingTransportIndex"
        :transport="localSiblingTransport"
        :default-transport="defaultTransport"
        :default-trip="defaultTrip"
        :default-trip-seating="defaultTripSeating"
        :default-trip-consumables="defaultTripConsumables"
        :default-trip-upgrade="defaultTripUpgrade"
        :default-luggage="defaultLuggage"
        :sibling-created="siblingCreated"
        @update="updateTransport"
        @save="saveTransport"
      />
      <!--DEPRECATED FOR NOW-->
      <!--<v-flex>
        <v-btn
          v-if="!localSiblingTransport"
          class="mt-4"
          color="success"
          @click="createSibling"
        >
          {{ $t('buttons.createSibling') }}
        </v-btn>
        <v-btn
          v-else
          class="mt-4"
          dark
          color="red darken-4"
          @click="deleteSibling"
        >
          {{ $t('buttons.deleteSibling') }}
        </v-btn>
      </v-flex>-->
    </div>
  </v-content>
</template>

<style scoped lang="scss">
  @import '../../assets/scss/variables.scss';

  .alert {
    margin-bottom: $margin-s;
    width: 60%;
    margin-left: 13%;
    position: fixed;
    z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/pages/non-dynamic-transport/NonDynamicTransportCreate.vue